/* eslint no-param-reassign: 0 */

import _ from 'underscore';

export default class BaseRepository {
  renameProperty(params, oldName, newName) {
    if (oldName === newName || !_.has(params, oldName)) {
      return params;
    }

    return _.chain(params)
      .pairs()
      .map((pair) => {
        if (pair[0] === oldName) {
          pair[0] = newName;
        }
        return pair;
      }).object().value();
  }

  adaptParams(params) {
    //rename skip to offset
    if (params.skip) {
      params = this.renameProperty(params, 'skip', 'offset');
    }

    if (params.where && params.where.name) {
      params.where = this.renameProperty(params.where, 'name', '*');
    }

    return params;
  }
}
